/* eslint-disable react/prop-types */
import React, { useState, useContext } from 'react';
import {
  Button as MuiButton,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
} from '@material-ui/core';
import api from '../../service/axios/api';
import {
  CadastroGlobalStyle,
  Base,
  Lateral,
  Logo,
  TextPosition,
  TextWelcome,
  CadastroDescription,
  CadastroMain,
  CadastroContainer,
  CadastroTitle,
  CadastroSubtitle,
  CadastroForm,
  CadastroTextField,
  CadastroDadosRow,
  TermoArea,
  TermoLink,
  TermoError,
  CadastroButton,
  TermoContent,
  TermoActions,
} from './CadastroPortadorStyles';
import Button from '../../components/button/MyButton';
import Loading from '../../components/loading/Loading';
import FlashContext from '../../components/contexts/FlashContext';

const CadastroPortador = function () {
  const [openTermo, setOpenTermo] = useState(false);

  const [form, setForm] = useState({
    nome: '',
    dataNascimento: '',
    cpf: '',
    nomeMae: '',
    email: '',
    telefone: '',
    celular: '',
    aceiteTermo: false,
  });
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');
  const [errors, setErrors] = useState({});
  const { notifyError, notifySuccess } = useContext(FlashContext);

  const handleChange = event => {
    const { name, value, checked, type } = event.target;

    setForm(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));

    setErrors(prev => ({
      ...prev,
      [name]: '',
    }));
  };

  const formatCpf = value => {
    const numbers = value.replace(/\D/g, '').slice(0, 11);

    return numbers
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  };

  const formatPhone = value => {
    const numbers = value.replace(/\D/g, '').slice(0, 11);

    if (numbers.length <= 10) {
      return numbers
        .replace(/(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{4})(\d)/, '$1-$2');
    }

    return numbers
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{5})(\d)/, '$1-$2');
  };

  const handleCpfChange = event => {
    setForm(prev => ({
      ...prev,
      cpf: formatCpf(event.target.value),
    }));

    setErrors(prev => ({
      ...prev,
      cpf: '',
    }));
  };

  const handlePhoneChange = event => {
    const { name, value } = event.target;

    setForm(prev => ({
      ...prev,
      [name]: formatPhone(value),
    }));
  };

  const validate = () => {
    const newErrors = {};

    if (!form.nome.trim()) {
      newErrors.nome = 'Nome é obrigatório';
    }

    if (!form.dataNascimento) {
      newErrors.dataNascimento = 'Data de nascimento é obrigatória';
    }

    if (!form.cpf.trim()) {
      newErrors.cpf = 'CPF é obrigatório';
    }

    if (!form.email.trim()) {
      newErrors.email = 'E-mail é obrigatório';
    } else if (!/\S+@\S+\.\S+/.test(form.email)) {
      newErrors.email = 'Informe um e-mail válido';
    }

    if (!form.aceiteTermo) {
      newErrors.aceiteTermo = 'É necessário aceitar o termo';
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (!validate()) return;
    setLoading(true);
    setMsg('Enviando Dados...');
    const data = {
      ...form,
      cpf: form.cpf.replace(/\D/g, ''),
      telefone: form.telefone.replace(/\D/g, ''),
      celular: form.celular.replace(/\D/g, ''),
    };

     api.individual.dadosPortador(data.nome, 
      data.dataNascimento, 
      data.cpf, 
      data.nomeMae,
      data.email, 
      data.telefone, 
      data.celular, 
      data.aceiteTermo,
    ).then((ret) => {
        notifySuccess(ret.message);
      })
      .catch(err => {
        notifyError(err.message);
      })
      .finally(() => setLoading(false));

      };

  const handleAceitarTermo = () => {
    setForm(prev => ({
      ...prev,
      aceiteTermo: true,
    }));

    setErrors(prev => ({
      ...prev,
      aceiteTermo: '',
    }));

    setOpenTermo(false);
  };

return (
  <>
  
     <CadastroGlobalStyle />
  <Loading open={loading} msg={msg} />
    <Base>
      <Lateral>
        <Logo
          loading="eager"
          src="img/controlEcosystemnova3.png"
          alt="Control EcoSystem"
        />

        <TextPosition>
          <TextWelcome>
            Cadastro de Portador
          </TextWelcome>

          <CadastroDescription>
            Preencha seus dados para concluir o cadastro e confirmar seu cadastro!
          </CadastroDescription>
        </TextPosition>
      </Lateral>

      <CadastroMain>
        <CadastroContainer>
          <CadastroTitle>
            Dados Cadastrais
          </CadastroTitle>
          <CadastroSubtitle>
            Os campos com * são obrigatórios.
          </CadastroSubtitle>
          <CadastroForm>

              <CadastroTextField
                name="nome"
                label="Nome *"
                value={form.nome}
                onChange={handleChange}
                error={Boolean(errors.nome)}
                helperText={errors.nome}
                variant="outlined"
                fullWidth
              />
              <CadastroDadosRow>
              <CadastroTextField
                name="dataNascimento"
                label="Data de nascimento *"
                type="date"
                value={form.dataNascimento}
                onChange={handleChange}
                error={Boolean(errors.dataNascimento)}
                helperText={errors.dataNascimento}
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                fullWidth
              />

              <CadastroTextField
                name="cpf"
                label="CPF *"
                value={form.cpf}
                onChange={handleCpfChange}
                error={Boolean(errors.cpf)}
                helperText={errors.cpf}
                variant="outlined"
                inputProps={{
                  maxLength: 14,
                }}
                fullWidth
                />
              </CadastroDadosRow>
                <CadastroTextField
                  name="nomeMae"
                  label="Nome da mãe"
                  value={form.nomeMae}
                  onChange={handleChange}
                  variant="outlined"
                  fullWidth
                />

                <CadastroTextField
                  name="email"
                  label="E-mail"
                  type="email"
                  value={form.email}
                  onChange={handleChange}
                  variant="outlined"
                  fullWidth
                />
              <CadastroDadosRow>
                <CadastroTextField
                  name="telefone"
                  label="Telefone"
                  value={form.telefone}
                  onChange={handlePhoneChange}
                  variant="outlined"
                  fullWidth
                />

                <CadastroTextField
                  name="celular"
                  label="Celular"
                  value={form.celular}
                  onChange={handlePhoneChange}
                  variant="outlined"
                  fullWidth
                />
              </CadastroDadosRow>

              <TermoArea>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="aceiteTermo"
                      checked={form.aceiteTermo}
                      onChange={handleChange}
                      color="primary"
                    />
                  }
                  label={
                    <span>
                      Li e concordo com o{' '}
                      <TermoLink
                        type="button"
                        onClick={event => {
                          event.preventDefault();
                          event.stopPropagation();
                          setOpenTermo(true);
                        }}
                      >
                        Termo de aceite *
                      </TermoLink>
                      .
                    </span>
                  }
                />

                {errors.aceiteTermo && (
                  <TermoError>
                    {errors.aceiteTermo}
                  </TermoError>
                )}
              </TermoArea>

              <CadastroButton>
                <Button
                  onClick={handleSubmit}
                  label="Concluir cadastro"
                />
              </CadastroButton>

            </CadastroForm>
          </CadastroContainer>
        </CadastroMain>
      </Base>

      <Dialog
        open={openTermo}
        onClose={() => setOpenTermo(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          style: {
            width: 'calc(100% - 32px)',
            maxWidth: '500px',
            margin: '16px',
            borderRadius: '12px',
          },
        }}
      >
        <DialogTitle>
          Termo de aceite
        </DialogTitle>

        <DialogContent dividers>
          <TermoContent>
            <p>
              Insira aqui o conteúdo do Termo de Aceite.
            </p>
          </TermoContent>
        </DialogContent>

        <DialogActions style={{ padding: 0 }}>
          <TermoActions>
            <MuiButton
              variant="outlined"
              onClick={() => setOpenTermo(false)}
            >
              Fechar
            </MuiButton>

            <MuiButton
              variant="contained"
              onClick={handleAceitarTermo}
            >
              Li e concordo
            </MuiButton>
          </TermoActions>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CadastroPortador;